import * as React from 'react';
import './_ColorRow.scss';
import { IColorRowProps } from './types';
import { CLASS_COLOR_PALETTE } from '../constants';
import { Color } from '../Color/Color';
import { Button, ButtonDropdown } from 'kui';
import {
    COLOR_ROW_PICKER_BUTTON_CANCEL,
    COLOR_ROW_PICKER_BUTTON_SAVE,
    COLOR_ROW_PICKER_DEFAULT_COLOR
} from './constants';
import { NEW_COLORS } from '../../../../../../store/model/board/selectors/getBoardColors';
import { ColorPicker, useColor } from 'react-color-palette';
import 'react-color-palette/css';
import { CARD_CONTROL_CLASS, LIST_CONTROL_CLASS } from '../../../../main/kanbanView';
import { root } from '../../../../../../store/constants';
import { COLOR_BLINK_ANIMATION_TIMEOUT } from '../Color/constants';

export const ColorRow = ({
    allColors,
    colors,
    isAutoFocus,
    isColorPicker,
    selectedColor,
    variant,
    onSelect,
    setColorPickerOpen,
}: IColorRowProps) => {
    const className = CLASS_COLOR_PALETTE + '-color-row';
    const classPicker = className + '__picker';

    const [isOpen, setOpen] = React.useState(null);
    const [colorPickerDirection, setColorPickerDirection] = React.useState<'left' | 'right'>('left');
    const [color, setColor] = useColor(COLOR_ROW_PICKER_DEFAULT_COLOR);

    const onSave = () => {
        onSelect(color.hex, true);
        setOpen(false);
        setTimeout(() => { // ждем пока дропдаун закроется
            const color = document.querySelector(`.${CLASS_COLOR_PALETTE}-color--selected`) as HTMLElement;
            if (!color) return;
            const className = `${CLASS_COLOR_PALETTE}-color--new`;
            color.classList.add(className);
            setTimeout(() => {
                color.classList.remove(className);
            }, COLOR_BLINK_ANIMATION_TIMEOUT);
        }, 400);
    };

    React.useEffect(() => {
        if (!isColorPicker) return;
        const onResize = () => {
            const container = document.querySelector(`.${className}`);
            if (!container) return;
            const picker = document.querySelector(`.${classPicker}-button`);
            if (!picker) return;
            const pickerRect = picker.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            setColorPickerDirection(pickerRect.right > (containerRect.right - containerRect.width / 2) ? 'right' :'left');
        }
        onResize();
        root.addEventListener('resize', onResize);
        return () => root.removeEventListener('resize', onResize);
    }, [isColorPicker, colors]);

    const isDisabled = !!NEW_COLORS.find(item => item.hex === color.hex) || !!allColors.find(item => item === color.hex);

    const ColorPickerIcon = require('!!@svgr/webpack!./color-picker.svg').default;

    return (
        <div className={className}>
            {colors.map(colorLabel => (
                <Color
                    key={colorLabel}
                    color={colorLabel}
                    isAutoFocus={isAutoFocus}
                    isSelected={colorLabel === selectedColor}
                    variant={variant}
                    onSelect={() => onSelect(colorLabel)}
                />
            ))}
            {isColorPicker &&
                <ButtonDropdown
                    className={classPicker + '-button'}
                    opened={isOpen}
                    onOpen={() => {
                        setColorPickerOpen(true);
                        setOpen(true);
                    }}
                    onClose={() => {
                        setColorPickerOpen(false);
                        setOpen(false);
                    }}
                    dropdownClassName={classPicker + '-dropdown'}
                    isFitWindow
                    portal
                    directionVertical={'up'}
                    directionHorizontal={colorPickerDirection}
                >
                    <Button variant={'icon'}>
                        <ColorPickerIcon />
                    </Button>
                    <div className={`${classPicker} ${LIST_CONTROL_CLASS} ${CARD_CONTROL_CLASS}`} >
                        <div className={classPicker + '-color'} style={{ backgroundColor: color.hex }} />
                        <ColorPicker color={color} onChange={setColor} hideInput={['rgb', 'hsv']} height={140} />
                        <div className={classPicker + '-actions'}>
                            <Button
                                onClick={() => setOpen(false)}
                                variant={'secondary'}
                            >
                                {COLOR_ROW_PICKER_BUTTON_CANCEL}
                            </Button>
                            <Button
                                onClick={onSave}
                                variant={'primary'}
                                disabled={isDisabled}
                            >
                                {COLOR_ROW_PICKER_BUTTON_SAVE}
                            </Button>
                        </div>
                    </div>
                </ButtonDropdown>
            }
        </div>
    );
}
